export const MAX_DIGITS = 15;

const BN = [
    '', 'এক', 'দুই', 'তিন', 'চার', 'পাঁচ', 'ছয়', 'সাত', 'আট', 'নয়',
    'দশ', 'এগারো', 'বারো', 'তেরো', 'চৌদ্দ', 'পনেরো', 'ষোলো', 'সতেরো', 'আঠারো', 'উনিশ',
    'বিশ', 'একুশ', 'বাইশ', 'তেইশ', 'চব্বিশ', 'পঁচিশ', 'ছাব্বিশ', 'সাতাশ', 'আঠাশ', 'উনত্রিশ',
    'ত্রিশ', 'একত্রিশ', 'বত্রিশ', 'তেত্রিশ', 'চৌত্রিশ', 'পঁয়ত্রিশ', 'ছত্রিশ', 'সাতত্রিশ', 'আটত্রিশ', 'উনচল্লিশ',
    'চল্লিশ', 'একচল্লিশ', 'বিয়াল্লিশ', 'তেতাল্লিশ', 'চৌচল্লিশ', 'পঁয়তাল্লিশ', 'ছেচল্লিশ', 'সাতচল্লিশ', 'আটচল্লিশ', 'উনপঞ্চাশ',
    'পঞ্চাশ', 'একান্ন', 'বায়ান্ন', 'তিপান্ন', 'চুয়ান্ন', 'পঞ্চান্ন', 'ছাপান্ন', 'সাতান্ন', 'আটান্ন', 'উনষাট',
    'ষাট', 'একষট্টি', 'বাষট্টি', 'তেষট্টি', 'চৌষট্টি', 'পঁয়ষট্টি', 'ছেষট্টি', 'সাতষট্টি', 'আটষট্টি', 'উনসত্তর',
    'সত্তর', 'একাত্তর', 'বাহাত্তর', 'তেহাত্তর', 'চুয়াত্তর', 'পঁচাত্তর', 'ছিয়াত্তর', 'সাতাত্তর', 'আটাত্তর', 'উনআশি',
    'আশি', 'একাশি', 'বিরাশি', 'তিরাশি', 'চুরাশি', 'পঁচাশি', 'ছিয়াশি', 'সাতাশি', 'আটাশি', 'উননব্বই',
    'নব্বই', 'একানব্বই', 'বিরানব্বই', 'তিরানব্বই', 'চুরানব্বই', 'পঁচানব্বই', 'ছিয়ানব্বই', 'সাতানব্বই', 'আটানব্বই', 'নিরানব্বই',
];

const EN_ONES = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
    'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
const EN_TENS = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

function enUpTo99(n) {
    if (n < 20) return EN_ONES[n];
    return EN_TENS[Math.floor(n / 10)] + (n % 10 ? ` ${EN_ONES[n % 10]}` : '');
}

function enUpTo999(n) {
    if (n < 100) return enUpTo99(n);
    const rem = n % 100;
    return `${EN_ONES[Math.floor(n / 100)]} Hundred${rem ? ` ${enUpTo99(rem)}` : ''}`;
}

function enCore(num) {
    if (num === 0) return '';
    let n = num;
    const parts = [];
    if (n >= 10_000_000) {
        parts.push(`${enCore(Math.floor(n / 10_000_000))} Crore`);
        n %= 10_000_000;
    }
    if (n >= 100_000) {
        parts.push(`${enUpTo99(Math.floor(n / 100_000))} Lakh`);
        n %= 100_000;
    }
    if (n >= 1_000) {
        parts.push(`${enUpTo99(Math.floor(n / 1_000))} Thousand`);
        n %= 1_000;
    }
    if (n >= 100) {
        parts.push(`${EN_ONES[Math.floor(n / 100)]} Hundred`);
        n %= 100;
    }
    if (n > 0) parts.push(enUpTo99(n));
    return parts.join(' ');
}

export function numberToEnglish(num) {
    return num === 0 ? 'Zero Only' : `${enCore(num)} Only`;
}

function bnCore(num) {
    if (num === 0) return '';
    let n = num;
    const parts = [];
    if (n >= 10_000_000) {
        parts.push(`${bnCore(Math.floor(n / 10_000_000))} কোটি`);
        n %= 10_000_000;
    }
    if (n >= 100_000) {
        parts.push(`${BN[Math.floor(n / 100_000)]} লক্ষ`);
        n %= 100_000;
    }
    if (n >= 1_000) {
        parts.push(`${BN[Math.floor(n / 1_000)]} হাজার`);
        n %= 1_000;
    }
    if (n >= 100) {
        parts.push(`${BN[Math.floor(n / 100)]} শত`);
        n %= 100;
    }
    if (n > 0) parts.push(BN[n]);
    return parts.join(' ');
}

export function numberToBengali(num) {
    return num === 0 ? 'শূন্য' : `${bnCore(num)} `;
}

export function sanitizeNumberInput(value) {
    return value.replace(/[^0-9০-৯]/g, '').slice(0, MAX_DIGITS);
}

export function parseNumberInput(value) {
    if (value === '') return null;
    const bnDigits = '০১২৩৪৫৬৭৮৯';
    const normalised = value.replace(/[০-৯]/g, (d) => bnDigits.indexOf(d));
    const n = parseInt(normalised, 10);
    if (Number.isNaN(n) || n < 0) return null;
    return n;
}

export function convertNumberToWords(value) {
    const parsed = parseNumberInput(value);
    if (parsed === null) {
        return { parsed: null, english: '', bengali: '' };
    }
    return {
        parsed,
        english: numberToEnglish(parsed),
        bengali: numberToBengali(parsed),
    };
}
